import axios from 'axios';
import { Endpoints } from '../../data/api/endpoints';
import { url } from '../../data/api/util';
import { IPaymentMethodActions } from './models';
import { each, find, get, isEmpty } from 'lodash';
import { IPaymentMethod } from '../../data/api/models';

export const addNewCard = (customerId: string, channelId: string, formValues, callback) => {
  const dataMap = {
    meta: {
      billing: {
        address: get(formValues, 'meta.billing.address'),
        title: get(formValues, 'meta.billing.title'),
        first_name: get(formValues, 'meta.billing.firstName', get(formValues, 'meta.billing.first_name', null)),
        last_name: get(formValues, 'meta.billing.lastName', get(formValues, 'meta.billing.last_name', null)),
      },
      permissions: get(formValues, 'meta.permissions'),
      reuse_customer_address: get(formValues, 'meta.reuseCustomerAddress', get(formValues, 'meta.reuse_customer_address', false)),
    }
  }

  return (dispatch) => {
    return axios.post(
      url(Endpoints.ADD_NEW_CARD, { params: { id: customerId, channel_id: channelId } }),
      dataMap
    ).then(() => {
      callback(dispatch);
      return true;
    }).catch((error) => {
      let transactionId = '';
      each(error.response.data.errors, (e) => {
        if (e.id !== 'redirect-to-provider') {
          return;
        }

        transactionId = e.data.transactionId;
      });

      callback(dispatch, transactionId);
    })
  }
}

export const assignCardToPolicy = (customerId: string, policyId: string, customerPaymentMethodId: string, callback: any) => {
  return () => {
    return axios.post(
      url(Endpoints.ASSIGN_CARD_TO_POLICY, { params: { id: customerId, customerPaymentMethodId } }),
      { data: [policyId] }
    ).then(() => {
      callback(true);
    }).catch(() => {
      callback(false);
    })
  }
}

export const getPaymentMethods = () => {
  return (dispatch, getState) => {
    return get(getState(), 'auth.customer.paymentMethods', [])
  }
}

export const getPolicyPaymentMethod = (assignedPaymentMethod: IPaymentMethod) => {
  return (dispatch, getState) => {
    const customerPaymentMethods = get(getState(), 'auth.customer.paymentMethods', []);
    if (!isEmpty(customerPaymentMethods) && !isEmpty(assignedPaymentMethod)) {
      return find(customerPaymentMethods, ['id', get(assignedPaymentMethod, 'id')])
    }

    return null;
  }
}

export const paymentMethodActions: IPaymentMethodActions = {
  addNewCard,
  assignCardToPolicy,
  getPaymentMethods,
  getPolicyPaymentMethod,
}
